import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { getVideoErr } from '../../services/VideoService';
import { DeviceVideoErrResponse } from '../../types/Videos';

function useGetDeviceErr(
  deviceId: string,
  enabled: boolean = true,
): UseQueryResult<DeviceVideoErrResponse> {
  return useQuery(
    ['device-config', deviceId, enabled],
    async (): Promise<DeviceVideoErrResponse> => getVideoErr(deviceId),
    {
      retry: 1,
      retryDelay: 3000,
      cacheTime: 0,
      refetchOnWindowFocus: false,
      enabled,
    },
  );
}

export default useGetDeviceErr;
